/**
 * Definição canônica das abas do editor de Playbook (Brief 4 · Tela 1 — 9 abas do gabarito
 * + a aba 10 «Conduta», da Fase 2, cujo campo não existia quando o gabarito foi desenhado).
 *
 * Ordem e rótulos do gabarito (design-references/brief-4/r1/shared/playbook-tabs.jsx).
 *
 * `state` reflete a triangulação R15 + o faseamento da sprint:
 *   - 'ready'            → implementada nesta fatia (PR1: só Geral).
 *   - 'soon'            → tem campo no backend; chega em fatia futura.
 *   - 'deferred-backend' → NÃO há campo no modelo Playbook (Gatilhos/Verificação);
 *                          honest-defer até o backend expor (não fabricar).
 */

export type PlaybookTabKey =
  | 'general'
  | 'steps'
  | 'operation'
  | 'triggers'
  | 'appetite'
  | 'verification'
  | 'quickreplies'
  | 'autocloseable'
  | 'checklist'
  | 'conduct';

export type PlaybookTabState = 'ready' | 'soon' | 'deferred-backend';

export interface PlaybookTabDef {
  /** Número exibido (1..9), conforme o gabarito. */
  id: number;
  key: PlaybookTabKey;
  label: string;
  state: PlaybookTabState;
}

export const PLAYBOOK_TABS: readonly PlaybookTabDef[] = [
  { id: 1, key: 'general', label: 'Geral', state: 'ready' },
  { id: 2, key: 'steps', label: 'Etapas', state: 'ready' },
  { id: 3, key: 'operation', label: 'Autonomia', state: 'ready' },
  { id: 4, key: 'triggers', label: 'Gatilhos', state: 'ready' },
  { id: 5, key: 'appetite', label: 'Apetite', state: 'ready' },
  { id: 6, key: 'verification', label: 'Verificação', state: 'ready' },
  { id: 7, key: 'quickreplies', label: 'Quick replies', state: 'ready' },
  { id: 8, key: 'autocloseable', label: 'Auto-close', state: 'ready' },
  { id: 9, key: 'checklist', label: 'Checklist', state: 'ready' },
  // Fase 2 «Conduta e Contexto» — os 5 eixos de conduta no nível PLAYBOOK (vence o Tenant,
  // perde da Persona). Aba 10: fora do gabarito de 9 abas do Brief 4 porque o campo não
  // existia quando o gabarito foi feito (a migration é de 05/Ago/2026).
  { id: 10, key: 'conduct', label: 'Conduta', state: 'ready' },
];
